// extracted by mini-css-extract-plugin
export var logoContainer = "_vWFlXi4WaSIkhruwYnR";
export var logoImage = "PL3JVLPydqKwLVoy0GS6";